import { brandList } from "./app.values";
import { AREA, DISTANCE, LOAD, MOMENT, STRENGTH, TEMPERATURE, WEIGHT } from '@reducers/units';

export const APP_TYPES = {
  GENERAL_CALCULATION: 'general-calculation',
  BRACKET_ATTACHMENT: 'bracket-attachment',
  SAFETY_BARRIER: 'safety-barrier',
  REBAR_REINFORCEMENT: 'rebar-reinforcement',
  WOOD_CONNECTION: 'wood-connection'  
};

export const BRAND = brandList.Ramset;
export const PROJECT_VERSION = 7;

export const appConfig = {
  BASE_URL: 'https://anchor-design.itwcp.com',
  API_PATH: '/iRamset/Spit.iExpert.Services.svc', 

  nonAuthPath: {
    // AVAILABLE_COUNTRIES: '/GetAvailableCountries',
    COUNTRY_PROFILES: '/GetCountryAvailableProfileTypes',
    DESIGN_STANDARDS: '/GetCurrentCountryDesignStandardList',
    INIT: '/InitializeSession',
    AVAILABLE_LANGUAGES: '/GetAvailableLanguages',
    GET_OLD_PROFILE: '/GetOldProfile',
    GET_CURRENT_VERSIONS: '/GetCurrentVersions'
  },

  path: {
    AVAILABLE_COUNTRIES: '/GetAvailableCountries',
    UPDATE_SESSION: '/UpdateClientInfo',
    BOND_CONDITIONS: '/GetBondConditions',
    BUILDING_IMPORTANCE: '/GetBuildingImportance',
    CONCRETE_STRENGTH: '/GetConcreteStrength',
    CONCRETE_STRENGTH_VALUE: '/GetConcreteStrengthValue',
    CONCRETE_CONDITIONS: '/GetConcreteConditions',
    EDGE_REINFORCEMENT: '/GetEdgeReinforcement',
    FIRE_SIDES: '/GetFireSides',
    HOLE_CONDITIONS: '/GetHoleConditions',
    INSTALLATION_CONDITIONS: '/GetInstallationConditions',
    INSTALLATION_CONDITIONS_ANCHORS: '/GetInstallationConditionsAnchors',
    LONG_TERM_CONDITIONS: '/GetLongTermTemperature',
    MATERIAL_NAMES: '/GetAvailableMaterialNames',
    PLATE_REINFORCEMENT: '/GetPlateReinforcement',
    PROFILE_TYPES: '/GetAvailableProfileTypes',
    PROFILE_SIZES: '/GetAvailableProfilesForType',
    RANGE_TEMPERATURE: '/GetRangeTemperature',
    SAFETY_BARRIER_PROFILES: '/GetAvailableSafetyBarrierProfiles',
    SEISMICITY_LEVELS: '/GetSeismicityLevels',
    SHEAR_LOAD_CONDITIONS: '/GetShearLoadConditions',
    SHORT_TERM_CONDITIONS: '/GetShortTermTemperature',
    TENSION_LOAD_CONDITIONS: '/GetTensionLoadConditions',
    BEAM_PROFILE_SHAPE: '/GetBeamProfileShape',
    INSTALLATION_METHOD: '/GetInstallationMethodLink',
    INSTALLATION_DATA: '/GetInstallationData',
    GET_DOCUMENT: '/GetDocumentLink',
    ERROR_MESSAGES: '/GetResultErrorMessages',

    ANCHOR_RESULTS_INTERNAL: '/GetAnchorResultsInternal',
    ANCHOR_RESULTS: '/GetAnchorResultsWeb',
    GET_PHOTO: '/GetPhotoByte',

    PREPARE_REPORT_IMAGE: '/PrepareReportImage',

    GENERATE_REPORT_WEB: '/GenerateReportWeb',

    SWITCH_LANGUAGE: '/SwitchLanguage',
    GET_TRANSLATION: '/GetTranslation',
    GET_TRANSLATIONS: '/GetTranslations',

    MASONRY_SERVICE_TEMPERATURE: '/GetMasonryServiceTemperature',
    MASONRY_MATERIALS: '/GetMasonryMaterials',
    MASONRY_MATERIAL_INFO: '/GetMasonryMaterialInfo',
    MASONRY_MATERIAL_DESIGN_RESISTANCE: '/GetMasonryMaterialDesignResistance',
    MASONRY_PRODUCTS: '/GetMasonryAnchors',
    MASONRY_SIZES: '/GetMasonryAnchorDimensions',

    UPDATE_UNITS: '/UpdateClientUnits',

    RUN_FEM_CALCULATION: '/RunFEMCalculation',
    CANCEL_FEM_CALCULATION: '/CancelFEMCalculation',

    CALCULATE_PROFILE_RESISTANCE: '/CalculateProfileResistance',

    GET_FRENCH_AREAS: '/GetFrenchAreas',
    STEEL_TYPES: '/GetSteelTypeFilterItems',

    GET_CURRENT_COUNTRY_INFO: '/GetCurrentCountryInfo',

    KEEP_CALCULATION_RUNNING: '/KeepCalculationRunning',
    CANCEL_CALCULATION: '/CancelCalculation',

    GET_SB_PREDEFINED_BASE_PLATES: '/GetSBPredefinedBasePlates',
    GET_SB_PREDEFINED_BASE_PLATE: '/GetSBPredefinedBasePlate',
      GET_SB_PREDEFINED_BASE_PLATE_IMAGE: '/GetSBPredefinedBasePlateImage',
    WOOD_CONNECTION_MATERIALS: '/GetMaterialWoodConnection'
  },

  APP_TYPES

};

export const defaultUnits = {
  DISTANCE: DISTANCE.MILLIMETERS,
  AREA: AREA.SQUARE_MILLIMETERS,
  STRENGTH: STRENGTH.NEWTON_SQUARE_MILLIMETERS,
  LOAD: LOAD.KILONEWTON,
  MOMENT: MOMENT.KILONEWTON_METER,
  TEMPERATURE: TEMPERATURE.CELSIUS,
  WEIGHT: WEIGHT.KILOGRAM
};

export const APP_STATES = {
  INITIALIZED: 'initialized',
  NOT_INITIALIZED: 'not-initialized',
  WAITING_RESPONSE: 'waiting-response', // reserved for future use
  REVIEW_OPTIONS: 'review-options',
  LOADING_NEW_STATE: 'loading-new-state'
};



// WEBPACK FOOTER //
// ./src/app.config.js